import axios from "axios";

export const adminApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

adminApi.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("lolopets_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export function formatApiError(error) {
    const detail = error?.response?.data?.detail;
    if (detail == null) return error?.message || "Algo salió mal. Intenta de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export async function uploadImage(file) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await adminApi.post("/admin/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
}
